import { apiCall, ApiResponse } from "./apiClient";

export interface PasswordChangeDto {
    oldPassword: string;
    newPassword: string;
}

export interface DefaultCultureDto {
    defaultCulture: string;
}

export const changeOwnPassword = (dto: PasswordChangeDto): Promise<ApiResponse<void>> => {
    return apiCall<void>("Employees/ChangeOwnPassword", "POST", dto);
};

export const changeDefaultCulture = (dto: DefaultCultureDto): Promise<ApiResponse<void>> => {
    return apiCall<void>("Employees/ChangeDefaultCulture", "POST", dto);
};
